// extracted by mini-css-extract-plugin
export default {"hover-wrapper":"_2yN-M","hoverWrapper":"_2yN-M"};